//import { addLocaleData } from 'react-intl';
import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import frLang from './entries/fr-FR';

const AppLocale = {
    en: enLang,
    es: esLang,
    fr: frLang
};
//addLocaleData(AppLocale.en.data);
//addLocaleData(AppLocale.es.data);
//addLocaleData(AppLocale.fr.data);

export default AppLocale;
